var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3312 54.8008C77.3312 54.8008 66.7883 71.1722 59.7597 74.0865C54.5312 76.3151 37.6455 82.4865 36.874 90.6293C46.7312 96.1151 51.274 105.544 51.274 105.544L82.0454 97.4865L77.3312 54.8008Z",
    fill: "#F0C1D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9027 82.4868C92.1598 62.4297 98.3312 35.344 87.8741 13.4011C85.9027 9.20114 79.9027 8.08682 76.1313 10.3154C72.3598 12.544 71.0741 17.8583 73.0455 22.0583C78.1884 32.8583 76.3027 45.544 72.7884 56.5154C69.2741 67.4868 68.8455 67.6583 65.0741 73.8297C59.3312 83.2583 74.1598 91.9154 79.9027 82.4868Z",
    fill: "#F0C1D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5597 74.0866C61.3025 74.1723 61.1311 74.258 60.874 74.4294C59.7597 74.9437 63.1025 73.7437 61.4739 74.1723C59.8454 74.6008 60.6168 74.5151 60.274 74.6008C57.874 75.458 55.474 76.1437 52.9882 76.4866C54.274 76.3151 52.8168 76.4866 52.3025 76.4866C51.7882 76.4866 50.8454 76.5723 50.0739 76.5723C49.3025 76.5723 48.5311 76.5723 47.7597 76.4866C46.9882 76.4009 48.1882 76.658 46.8168 76.3151C44.1597 75.6294 42.1025 74.858 40.3025 72.458C37.5597 68.7723 32.9311 66.8866 28.5597 69.3723C24.1882 71.858 22.6454 77.3437 25.4739 81.1152C32.0739 89.858 41.5882 94.5723 52.6454 93.6294C63.7025 92.6866 64.6454 91.5723 70.2168 88.8294C75.7882 86.0866 75.5311 80.858 73.3025 77.0866C71.074 73.3151 65.7597 71.9437 61.5597 74.0008V74.0866Z",
    fill: "#F0C1D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.531 90.8857C94.8167 78.2 99.8739 64.6572 100.902 51.2C101.931 37.7429 76.9882 25.6571 63.7024 21.2857C53.2453 17.7714 48.7024 34.3143 59.1596 37.8286C69.6167 41.3429 71.1596 42.1143 77.0739 45.2857C82.9882 48.4571 80.4167 47.1715 81.9596 48.3715C81.0167 47.6858 85.131 51.2857 83.5881 49.7429C84.6167 50.8572 83.7596 51.1143 83.8453 50C84.1024 47.6857 83.8453 49.3143 83.8453 49.8286C83.8453 50.3429 83.8453 51.0286 83.7596 51.5429C83.6739 53.0858 84.1024 50.1715 83.5881 52.4C81.2739 63.9715 77.8453 75.2 74.0739 86.3429C70.3024 97.4857 87.0167 101.257 90.6167 90.8857H90.531Z",
    fill: "#F0C1D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.074 100.83L96.7026 60.2871C96.7026 60.2871 71.1597 81.03 68.4169 83.5157C65.674 86.0014 49.1311 103.487 51.1883 105.544C53.2454 107.687 76.474 120.116 88.9883 100.83H89.074Z",
    fill: "#F0C1D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1882 47.5989C75.1882 47.5989 79.0453 33.4561 73.3882 23.3418",
    stroke: "#002E52",
    strokeWidth: 0.942857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1885 32.2565L59.5885 25.8279C58.9885 25.3994 58.1313 25.5707 57.7885 26.1707L33.0171 63.3708C30.7028 66.8851 31.3028 71.5136 34.4742 73.5707L34.7314 73.7422C37.9028 75.885 42.3599 74.685 44.7599 71.1707L69.5313 33.9708C69.9599 33.3708 69.7885 32.5136 69.1885 32.1707V32.2565Z",
    fill: "#F0C1D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5799 72.1822C33.0841 70.5176 31.9822 67.6898 33.1482 65.9415L43.109 51.0059C43.3755 50.6063 44.0032 50.5919 44.5737 50.9723L51.7761 55.7757C52.3466 56.1562 52.5745 56.7412 52.308 57.1409L42.3472 72.0765C41.1479 73.8748 38.1471 73.8943 35.6512 72.2297L35.5799 72.1822Z",
    fill: "#B6E5F0",
    stroke: "#F0C1D9",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8824 31.7591L64.1593 35.2784C65.2227 35.9876 66.6596 35.7005 67.3688 34.6372L70.7454 29.5741C71.4546 28.5107 71.1675 27.0738 70.1041 26.3646L64.8271 22.8453C63.7638 22.1362 62.3268 22.4233 61.6177 23.4867L58.241 28.5497C57.5319 29.6131 57.819 31.05 58.8824 31.7591Z",
    fill: "#F0C1D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7314 29.8596C67.8172 27.9739 64.9886 26.0025 62.0743 24.1168C59.16 22.2311 61.2172 23.6025 60.8743 23.2597C59.8457 22.574 58.8172 24.2882 59.8457 24.974C62.76 26.8597 65.5886 28.8311 68.5029 30.7168C71.4171 32.6025 69.36 31.2311 69.7029 31.5739C70.7314 32.2596 71.76 30.5453 70.7314 29.8596Z",
    fill: "#F0C1D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3599 27.4593C69.4456 25.5736 66.617 23.6021 63.7027 21.7164C60.7884 19.8307 62.8456 21.2021 62.5027 20.8593C61.4741 20.1736 60.4456 21.8878 61.4741 22.5736C64.3884 24.4593 67.217 26.4307 70.1313 28.3164C73.0456 30.2021 70.9884 28.8307 71.3313 29.1736C72.3599 29.8593 73.3884 28.145 72.3599 27.4593Z",
    fill: "#F0C1D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3174 33.3392L59.0487 26.4908C58.193 25.9201 57.9555 24.7314 58.5262 23.8757L62.7588 17.5291C64.138 15.4611 66.9433 14.9623 68.94 16.294L74.8588 20.2413C76.9268 21.6205 77.4255 24.4258 76.0939 26.4225L71.8612 32.7691C71.2905 33.6248 70.1018 33.8623 69.2461 33.2916L69.3174 33.3392Z",
    fill: "#CC5B9A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 47.836,
    y1: 41.4443,
    x2: 58.7328,
    y2: 48.3251,
    stroke: "#002E52",
    strokeWidth: 1.61093,
    strokeLinecap: "round",
    strokeDasharray: "3.22 3.22"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 44.8255,
    y1: 46.2119,
    x2: 55.7223,
    y2: 53.0927,
    stroke: "#002E52",
    strokeWidth: 1.61093,
    strokeLinecap: "round",
    strokeDasharray: "3.22 3.22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaSample);
export default __webpack_public_path__ + "static/media/dna-sample.2bc0ff9e359820a3507f50354e9b06fe.svg";
export { ForwardRef as ReactComponent };